import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Sparkles } from "lucide-react";
import MarketingLayout from "../../components/marketing/MarketingLayout";
import Seo from "../../components/Seo";
import api from "../../lib/api";

export default function Products() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/products").then(({ data }) => setProducts(data.items)).catch(() => {}); }, []);

  return (
    <MarketingLayout>
      <Seo title="Products — AllToMAIDIt Solutions" description="Explore AllToMAIDIt software products, starting with AllToMAIDIt CRM." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-20">
        <p className="eyebrow text-alto-red mb-3">Products</p>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-4">Software built to grow with you.</h1>
        <p className="text-neutral-400 max-w-2xl mb-14 text-sm sm:text-base">AllToMAIDIt products share one platform — authentication, multi-tenant data and billing — so new products can launch without rebuilding everything.</p>

        <div className="grid md:grid-cols-2 gap-6">
          {products.map((p) => (
            <Link key={p.id} to={`/products/${p.slug}`} data-testid={`product-card-${p.slug}`} className="card-hairline rounded-2xl p-8 bg-alto-charcoal group">
              <div className="flex items-center justify-between mb-6">
                <Users className="text-alto-red" size={30} />
                <span className="eyebrow px-3 py-1 rounded-full bg-alto-red/15 text-alto-red">{p.status}</span>
              </div>
              <h2 className="font-display text-2xl font-bold group-hover:text-alto-red transition-colors">{p.name}</h2>
              <p className="text-sm text-neutral-400 mt-3 leading-relaxed">{p.short_description}</p>
              <span className="inline-flex items-center gap-2 text-alto-red text-sm font-semibold mt-6">Explore product <ArrowRight size={15} /></span>
            </Link>
          ))}
          <div className="rounded-2xl p-8 border border-dashed border-white/15 flex flex-col justify-center items-start bg-black/40">
            <Sparkles className="text-neutral-500 mb-5" size={28} />
            <h2 className="font-display text-xl font-bold text-neutral-300">More products on the way.</h2>
            <p className="text-sm text-neutral-500 mt-3">Our platform is architected so new products, integrations and industry solutions can be added over time.</p>
            <Link to="/contact" className="text-alto-red text-sm font-semibold mt-5 inline-flex items-center gap-2">Tell us what you need <ArrowRight size={15} /></Link>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
